<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">{{ title }}</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<!-- Inventory Management -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="text">Tags Management</div>
								</div>
							</div>
						</div>
						<div class="integration-accounts">
							<div class="integration-account">
								<div class="wrapper" v-if="!!userSettings">
									<div class="container-fluid p-0">
										<div class="row">
											<!-- Order -->
											<div class="col-md-6">
												<div class="form-group">
													<label><b>Order Tags</b></label>
													<multiselect
														v-model="orderTags"
														placeholder="Input or Select Tag"
														label="name"
														track-by="name"
														:options="[]"
														:hide-selected="true"
														:multiple="true"
														:taggable="true"
														tag-placeholder="Press enter to insert tag"
														@tag="addTag($event, 'order')">
														<template slot="tag" slot-scope="{ option }">
															<span class="multiselect__tag">
																<span>{{ option.name }}</span>
																<span class="custom__remove" @click="removeTag($event, option)"><i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i></span>
															</span>
														</template>
													</multiselect>
												</div>
											</div>

											<!-- Contact -->
											<div class="col-md-6">
												<div class="form-group">
													<label><b>Contact Tags</b></label>
													<multiselect
														v-model="contactTags"
														placeholder="Input or Select Tag"
														label="name"
														track-by="name"
														:options="contactTags"
														:hide-selected="true"
														:multiple="true"
														:taggable="true"
														tag-placeholder="Press enter to insert tag"
														@tag="addTag($event, 'contact')">
														<template slot="tag" slot-scope="{ option }">
															<span class="multiselect__tag">
																<span>{{ option.name }}</span>
																<span class="custom__remove" @click="removeTag($event, option)"><i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i></span>
															</span>
														</template>
													</multiselect>
												</div>
											</div>

											<!-- Expense -->
											<div class="col-md-6">
												<div class="form-group">
													<label><b>Expense Tags</b></label>
													<multiselect
														v-model="expenseTags"
														placeholder="Input or Select Tag"
														label="name"
														track-by="name"
														:options="expenseTags"
														:hide-selected="true"
														:multiple="true"
														:taggable="true"
														tag-placeholder="Press enter to insert tag"
														@tag="addTag($event, 'expense')">
														<template slot="tag" slot-scope="{ option }">
															<span class="multiselect__tag">
																<span>{{ option.name }}</span>
																<span class="custom__remove" @click="removeTag($event, option)"><i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i></span>
															</span>
														</template>
													</multiselect>
												</div>
											</div>

										</div>
									</div>
								</div>
								<div class="is-loading large dark mt-3 mb-4" v-if="!userSettings"></div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
	<div class="modals">
	</div>

	<notifications group="general" position="bottom right" />
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters, mapActions } from 'vuex';
import tagApi from '../api/tag';
import { duplicateVar } from '../lib/helper';

export default {
	name: 'SettingsTag',
	components: {
		Multiselect,
	},
	data() {
		return {
			title: 'Tags',
			autoCancel: {
				enabled: false,
				type: 'day',
				value: 7,
			},
			userSettings: null,
			isSavingAutoCancel: false,
			isSavingEmailTransactionalSetting: false,
			isSavingSettings: false,
			contactTags: [],
			expenseTags: [],
			orderTags: [],
		};
	},
	methods: {
		...mapActions({
			setAutoCancel: 'setAutoCancel',
			setTransactionalEmail: 'setTransactionalEmail',
			setSettings: 'setSettings',
			getTags: 'settings/getTags',
			setTag: 'settings/setTag',
			deleteTag: 'settings/deleteTag',
			appendTag: 'settings/appendTag',
		}),
		getUserSettings() {
			if (this.settings) {
				this.userSettings = duplicateVar(this.settings);
			}
		},
		fetchTags() {
			const params = {
				limit: 100,
				sort_by: 'name',
				sort: 'desc',
				page: 1,
			};
			this.getTags(params);
		},
		categoriesTag() {
			this.contactTags = this.tags.filter(el => el.category === 'contact');
			this.expenseTags = this.tags.filter(el => el.category === 'expense');
			this.orderTags = this.tags.filter(el => el.category === 'order');
		},
		addTag(tag, type) {
			this.createTag(tag, type);
		},
		removeTag(e, tag) {
			e.preventDefault();

			const id = tag._id;
			const callback = (response) => {
				const message = response.message;
				this.deleteTag(id);
				this.$notify({
					group: 'general',
					title: 'Tag',
					text: message,
					type: 'success',
				});
			};
			tagApi.delete(id, callback);
		},
		createTag(name, type) {
			const params = {
				name,
				category: type,
			};

			const callback = (response) => {
				const data = response.data;
				const tag = {
					_id: data._id,
					name: data.name,
					category: data.category,
				};
				this.appendTag(tag);
				this.$notify({
					group: 'general',
					title: 'Tag',
					text: 'Tag created',
					type: 'success',
				});
			};

			const errorCallback = (err) => {
				// eslint-disable-next-line
				console.log('err tag', err);
			};

			tagApi.store(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			settings: 'settings',
			isAdmin: 'isAdmin',
			tags: 'settings/tags',
		}),
	},
	created() {
		this.fetchTags();
		if (this.user) {
			if (!this.userSettings) {
				this.getUserSettings();
			}
		}
	},
	mounted() {},
	watch: {
		user() {},
		tags() {
			this.categoriesTag();
		},
		settings() {
			this.getUserSettings();
		},
	},
};
</script>
